(function () {
    'use strict';

    function ServiceItemServantsController($scope, $state, ServantCustom, ServantSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $uibModal, Principal, DialogService) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        // $ctrl.activityType = '';
        $ctrl.newItem = newItem;
        $ctrl.removeServant = removeServant;
        //$ctrl.servants = null;

        $ctrl.servantToAdd = null;
        $ctrl.checkChange = checkChange;
        $ctrl.newServant = newServant;
        $ctrl.radioButtonChange = radioButtonChange;
        $ctrl.rbSelectedServantId = null;
        $ctrl.search = search;
        $ctrl.transition = transition;
        $ctrl.searchQuery = pagingParams.search;
        $ctrl.currentSearch = pagingParams.search;
        $ctrl.searchServantItem = searchServantItem;
        $ctrl.searchKeyPress = searchKeyPress;
        $ctrl.clearSearch = clearSearch;
        $ctrl.clear = clear
        $ctrl.servantItems = []
        loadAll();

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //


            ServantCustom.findServantsByCompany().query().$promise.then(function (result) {
                $ctrl.servantsByCompany = result;
                if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) {
                    if($ctrl.searchAble) {
                        $ctrl.servantItems = result;
                    }else {
                        $ctrl.servants = [];
                    }
                }
                else {
                    ServantCustom.findServantsByServiceItem($ctrl.serviceItemId).query().$promise.then(function (result) {
                        $ctrl.servants = result;
                        initSelectedItems();
                    });
                }
            });


        }

        function initSelectedItems() {

            angular.forEach($ctrl.servantsByCompany, function (v) {
                angular.forEach($ctrl.servants, function (savedServant) {
                    $ctrl.rbSelectedServantId = savedServant.id;
                    if (v.id == savedServant.id) {
                        v.selected = true;
                    }
                })
            })
            $ctrl.servantItems = $ctrl.servantsByCompany
        }

        function newItem() {
            if ($ctrl.servantToAdd) {
                var filtered = $ctrl.servants.filter(function (v) {
                    return (v.id == $ctrl.servantToAdd.id)
                });
                if (filtered.length == 0) {
                    $ctrl.servants.push({
                        id: $ctrl.servantToAdd.id,
                        title: $ctrl.servantToAdd.title,
                        level: $ctrl.servantToAdd.level,
                        personInfo: {
                            fisrtName: $ctrl.servantToAdd.personInfo.fisrtName,
                            lastName: $ctrl.servantToAdd.personInfo.lastName,
                            phoneNumber: $ctrl.servantToAdd.personInfo.phoneNumber
                        }
                    });
                    $ctrl.servantToAdd = null;
                }
            }
        }

        function removeServant(id) {

            //
            if (id) {
                $ctrl.servants = $ctrl.servants.filter(function (v) {
                        return (v.id != id)
                    }
                );
            }

        }

        function checkChange() {
            $ctrl.servants = [];
            angular.forEach($ctrl.servantsByCompany, function (servant) {
                if (servant.selected) {
                    $ctrl.servants.push({
                        id: servant.id,
                        title: servant.title,
                        level: servant.level,
                        personInfo: {
                            fisrtName: servant.personInfo.fisrtName,
                            lastName: servant.personInfo.lastName,
                            phoneNumber: servant.personInfo.phoneNumber
                        }
                    });
                }
            })


        }

        function newServant() {

            var result;
            Principal.getCurrentCompanyFeatureList();
            if ($ctrl.servantsByCompany) {
                result = Principal.canAddNewServant($ctrl.servantsByCompany.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }


            $uibModal.open({
                templateUrl: 'app/entities/servant/servant-by-company-dialog.html',
                controller: 'ServantByCompanyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: function () {
                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (v) {
                $ctrl.servantsByCompany.push(v);
                //reload();
            }, function () {
                //nothing
            });

        }


        function radioButtonChange() {
            $ctrl.servants = [];
            if ($ctrl.rbSelectedServantId) {
                angular.forEach($ctrl.servantsByCompany, function (servant) {
                    if (servant.id == $ctrl.rbSelectedServantId) {
                        $ctrl.servants.push({
                            id: servant.id,
                            title: servant.title,
                            level: servant.level,
                            personInfo: {
                                fisrtName: servant.personInfo.fisrtName,
                                lastName: servant.personInfo.lastName,
                                phoneNumber: servant.personInfo.phoneNumber
                            }
                        });
                    }
                })
            }

        }


        function search(searchQuery) {
            if (!searchQuery) {
                return  $ctrl.clear();
            }
            $ctrl.links = null;
            $ctrl.page = 1;
            $ctrl.predicate = '_score';
            $ctrl.reverse = false;
            $ctrl.currentSearch = searchQuery;
            $ctrl.transition();
        }
        function transition() {
            $state.transitionTo($state.$current, {
                page: $ctrl.page,
                sort: $ctrl.predicate + ',' + ($ctrl.reverse ? 'asc' : 'desc'),
                search: $ctrl.currentSearch
            });
        }

        function clear() {
            $ctrl.links = null;
            $ctrl.page = 1;
            $ctrl.predicate = 'id';
            $ctrl.reverse = true;
            $ctrl.currentSearch = null;
            $ctrl.transition();
        }
        function searchServantItem() {
            if (!$ctrl.searchQuery) {
                loadServantItems();
                return;
            }
            $ctrl.servantItems = $ctrl.servantsByCompany.filter(function (srv) {
                if (srv.servantName.includes($ctrl.searchQuery)) return true;
            })
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServantItem();
            }
        }
        function clearSearch() {
            $ctrl.searchQuery = null;
            searchServantItem();

        }
        function loadServantItems() {
            $ctrl.servantItems = $ctrl.servantsByCompany
        }


    }

    var ServiceItemServants = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-servants/partial-form.service-item-servants.html',
        controller: ServiceItemServantsController,
        bindings: {
            serviceItemId: '<',
            servants: '=',
            selectedId: '=?',
            formState: '=',
            activityType: '=?',
            singleSelection: '=',
            disableAddNew: '=?',
            searchAble: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemServants', ServiceItemServants)

    ServiceItemServantsController.$inject = ['$scope', '$state', 'ServantCustom', 'ServantSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$uibModal', 'Principal', 'DialogService'];


})();

